import React from 'react'

export const NavbarEnd = ({ children }) => {
  return <div className="navbar-end">{children}</div>
}
